// extracted by mini-css-extract-plugin
export default {"closeBtn":"CloseButton_closeBtn__0-Kog","closeBtnIcon":"CloseButton_closeBtnIcon__KIOU-"};